import { baseApi, baseRequest } from '@alltrails/redux-helpers';
import { TraillPolylinesResponse, getTrailPolylines } from '@alltrails/geo-service';
import { LngLat } from '../types/Geo';
import { legacyGeoJSONConversions } from '..';

// CONSIDER MOVING TO THE geo-service PACKAGE
export const geoServiceApi = baseApi.enhanceEndpoints({ addTagTypes: ['TrailPolyline'] }).injectEndpoints({
  endpoints: builder => ({
    /**
     * @deprecated Don't use this before checking with the DISCO team. GeoService is not ready for user-facing load yet.
     */
    getGeoServiceTrailPolyline: builder.query<LngLat[], number>({
      providesTags: ['TrailPolyline'],
      queryFn: trailId =>
        baseRequest(async () => {
          const response = await getTrailPolylines([trailId]);
          return legacyGeoJSONConversions.decodeSegmentLngLat({ polyline: { pointsData: response.trailMaps[0].polyline } });
        })
    }),
    /**
     * @deprecated Don't use this before checking with the DISCO team. GeoService is not ready for user-facing load yet.
     * Note that decoding polylines can take 2-3s for ~200 trails
     * Rather than allow our middleware to block for so long we'll return the raw response and allow consumers to decode
     */
    getGeoServiceTrailPolylines: builder.query<TraillPolylinesResponse, number[]>({
      queryFn: trailIds => baseRequest(() => getTrailPolylines(trailIds))
      // While it makes sense to insert each polyline into the cache individually doing so requires dispatching an action for each polyline
      // In practice this is prohibitively slow and ends up taking ~6s for ~200 trails during which the UI is unresponsive
      // Since fetching a single polyline is relatively performant we'll disable this caching for now
      // async onQueryStarted(_, { dispatch, queryFulfilled }) {
      //   try {
      //     const response = await queryFulfilled;
      //     response.data.features.forEach(feature => {
      //       dispatch(geoServiceApi.util.upsertQueryData('getGeoServiceTrailPolyline', feature.properties!.id, feature.geometry.coordinates as LngLat[]));
      //     });
      //     console.log(new Date().toISOString(), 'getGeoServiceTrailPolylines cache');
      //   } catch (error) {
      //     console.error('[geoServiceApi] error upserting trail polyline to cache:', error);
      //   }
      // }
    })
  })
});

export const {
  /**
   * @deprecated Don't use this before checking with the DISCO team. GeoService is not ready for user-facing load yet.
   */
  useGetGeoServiceTrailPolylineQuery,
  /**
   * @deprecated Don't use this before checking with the DISCO team. GeoService is not ready for user-facing load yet.
   */
  useGetGeoServiceTrailPolylinesQuery
} = geoServiceApi;
